import "./naf-insurance-task-banner.scss";
import nafInsuranceBlue from "assets/images/v2/naf-insurance-logo-blue.svg";
import { useState } from "react";
import { NAF_INSURANCE_TASKS_BANNER_CTA, NAF_INSURANCE_TASKS_BANNER_TEXT, NAF_INSURANCE_TASKS_BANNER_TEXT_NOTE } from "utilities/Constant";
import NafInsurancePanel from "../naf-insurance-panel/NafInsurancePanel";
import { trackFSInsuranceTaskCTAClick } from "utilities/full-story";
import { useInsuranceFullStoryTrackingProps } from "hooks/useInsuranceFullStoryTrackingProps";
import { Button } from "components/v2/button/Button";

export default function NafInsuranceTaskBanner() {
  const [isInsuranceModalOpen, setIsInsuranceModalOpen] = useState(false);
  const insuranceTrackingProps = useInsuranceFullStoryTrackingProps();

  const handleCtaClick = () => {
    trackFSInsuranceTaskCTAClick(insuranceTrackingProps);
    setIsInsuranceModalOpen(true);
  };

  return (
    <>
      <div className="naf-insurance-task-banner">
        <div className="naf-insurance-task-banner__logo"><img src={nafInsuranceBlue} alt="NAF Insurance logo" /></div>
        <div className="naf-insurance-task-banner__content">
          <div className="naf-insurance-task-banner__content-text paragraph-small-regular">
            {NAF_INSURANCE_TASKS_BANNER_TEXT}
          </div>
        </div>
        <div className="naf-insurance-task-banner__button-container">
          <Button
            variant="outline"
            label={NAF_INSURANCE_TASKS_BANNER_CTA}
            className="naf-insurance-task-banner__button"
            onClick={handleCtaClick}
          />
        </div>
      </div>
      <div className="naf-insurance-task-banner__note paragraph-small-italics">
        {NAF_INSURANCE_TASKS_BANNER_TEXT_NOTE}
      </div>
      {isInsuranceModalOpen && (
        <NafInsurancePanel
          onClose={() => setIsInsuranceModalOpen(false)}
          isTaskReferral
        />
      )}
      </>
  );
}